import React, { useState } from 'react';
import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import ErrorDisplay from '../ErrorDisplay';
import { Link, useLocation } from 'react-router';

interface LoadingProps {
	failed?: boolean;
	redirPage?: string;
}

const FullscreenLoading: React.FC<LoadingProps> = ({ failed, redirPage }) => {
	const location = useLocation();
	const [showRefresh, setShowRefresh] = useState<boolean>(false);

	setTimeout(() => setShowRefresh(true), 5 * parseInt(import.meta.env.VITE_API_RETRY_DELAY || '3000'));
	const refreshLink = redirPage || location.pathname.includes('callback') ? '/' : '.';

	return (
		<Stack spacing={4} minHeight="100vh" minWidth="100vw" justifyContent={'center'} alignItems={'center'}>
			{failed ? (
				<ErrorDisplay summaryText="An error occurred during sign-in" errorText="" />
			) : (
				<>
					<img src="/logo.png" height="120px" alt="Prometheus Logo" />
					<Typography variant="h3">Loading, please wait...</Typography>
					<Box width={'60%'} justifyContent={'center'} alignItems={'center'}>
						<LinearProgress variant="indeterminate" aria-label="Loading Progress Bar" />
					</Box>
					{showRefresh && (
						<Typography variant="h4">
							Not loading? Click{' '}
							<Link to={refreshLink} reloadDocument>
								here
							</Link>{' '}
							to refresh
						</Typography>
					)}
				</>
			)}
		</Stack>
	);
};

export default FullscreenLoading;
